import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"state_card"},[_c('div',{staticClass:"content"},[_c('h5',[_vm._v(_vm._s(_vm.name))]),_c('p',[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "+_vm._s(_vm.text)+" ")])]),(_vm.icon)?_c('div',{staticClass:"icon"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.actions}},[_c(VIcon,[_vm._v(_vm._s(_vm.icon))])],1)]):_vm._e(),_c('div',{staticClass:"icon_logo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }